export const sv = {
    header: {title: 'Digital provtagning', samplingSession: 'Digital provtagning'},
    join: {
        joinSession: 'Anslut till session',
        enterSessionId: 'Ange sessions-ID',
        connecting: 'Ansluter till session…',
    },
    controls: {
        microphone: 'Mikrofon',
        camera: 'Kamera',
        screenShareStart: 'Dela skärm',
        screenShareStop: 'Stoppa delning',
        close: 'Stäng',
        leave: 'Lägg på',
        notificationPlaceholder: 'Notifiering...',
        notify: 'Skicka',
        notificationInfo: 'Visa en notifiering, t.ex. en PIN-kod, för personen som testas',
        sending: 'Skickar..',
    },
    status: {settingUp: 'Startar…'},
    errors: {
        genericError: 'Något gick fel',
        tryAgainLater: 'Prova igen senare eller kontakta support',
    }
} as const;